// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LayoutSplitScreenImage_wrapper__3k8-3","bgImg":"LayoutSplitScreenImage_bgImg__9Blyp"};